import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { connect, useDispatch } from 'react-redux'
import { SAVE_PRISMIC_DOCUMENTS } from '../redux/actions/prismic'
import { Elements } from '@stripe/react-stripe-js'
import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core'
import PaymentFormStripe from '@/components/PaymentForm/PaymentFormStripe'
import Layout from '@/components/Layout/Layout'
import FunnelHeader from '@/components/Funnel/FunnelHeader'
import FunnelBox from '@/components/Funnel/FunnelBox'
import useFunnelStyle from '@/components/Funnel/Funnel.style'
import Commitment from '@/components/Commitment/Commitment'
import Link from '@/components/Link/Link'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { getTranslations } from '@/i18n'
import { useTranslation } from 'react-i18next'
import { checkTryOutError, numberToPrice, setFullLocale } from '@/utils/utils'
import { useCartHasStockError } from '@/hooks/useCartHasStockError'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import Button from '@/components/Button/Button'
import TextField from '@/components/TextField/TextField'
import { Cart, GAEvent } from '@/typings/base'
import TextBox from '@/components/TextField/TextBox'
import { useRouter } from 'next/router'
import CMSText, {
  isPrismicText,
  prismicText,
} from '@/components/Global/CMSText'
import { useStripePromise } from '@/utils/useStripePromise'
import { createCheckoutPayment } from '@/redux/actions/checkout'
import {
  postDadPayment,
  postSubPayment,
  postBypassDadPayment,
  postWireTransferDadPayment,
} from '@/redux/actions/payment'
import PaymentFormAdyen from '@/components/PaymentForm/PaymentFormAdyen'
import {
  BY_PASS_TYPE,
  byPassPassword,
  byPassPayment as brandBypassPayment,
  isSubscription,
  isWireTransferEnabled,
  minimumCartItemsNotReached,
} from '@/utils/constants'
import {
  getFunnelStepIndex,
  getPrevFunnelRoute,
  getStepperSteps,
} from '@/utils/funnel'
import { useInformationSkipped } from '@/hooks/useInformationSkipped'
import FunnelAside from '@/components/Funnel/FunnelAside'
import Loader from '@/components/Loader/Loader'
import * as gtag from '@/utils/gtag'
import {
  clearItemVariantFromGAParamsIfNotChalhoub,
  getPaymentInfoGtmData,
  isChalhoub,
  safeDataLayerPush,
} from '@/utils/gtag'
import { useCart } from '@/hooks/useCart'
import { createClient, getSingleDocument } from '@/prismicio'
import PaymentPaypal from '@/components/PaymentForm/PaymentPaypal'
import PaymentAccordion from '@/components/PaymentForm/PaymentAccordion'
import PaymentFormCheckout from '@/components/PaymentForm/PaymentFormCheckout'
import SwiklyCaution from '@/components/PaymentForm/SwiklyCaution'
import { PrismicFunnel } from '../interfaces/common/prismicFunnel'
import { PrismicGeneralConfig } from '../interfaces/common/prismicGeneralConfig'
import { setFunnelStep } from '../redux/actions/cart'
import { InferGetStaticPropsType } from 'next'
import { GetMapDispatchTypes } from '../interfaces/common/redux'

type Tprops = {
  doc?: PrismicFunnel
  basket?: any
  accountRes?: any
  faqRes?: any
  main?: PrismicGeneralConfig
  funnel?: PrismicFunnel
  inStoreText: any
  parameters?: any
  promotions: any
  checkout: any
  takeback: any
  postDadPayment: (data: object, token: string) => any
  postBypassDadPayment: (data: object, token: string) => any
  postWireTransferDadPayment: (data: object, token: string) => any
  postSubPayment: (data: object, token: string) => any
  cart: Cart
  createCheckoutPayment: (token: string) => any
  banner?: any
  setFunnelStep: (step: number) => void
  user: any
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  parameters: state.parameters,
  promotions: state.promotions,
  checkout: state.checkout,
  user: state.user.user,
  isLoggedIn: state.user.isLoggedIn,
})

const mapDispatchToProps = {
  createCheckoutPayment: createCheckoutPayment,
  postSubPayment: postSubPayment,
  postDadPayment: postDadPayment,
  postBypassDadPayment: postBypassDadPayment,
  postWireTransferDadPayment: postWireTransferDadPayment,
  setFunnelStep: setFunnelStep,
}

type TPaymentProps = Tprops &
  InferGetStaticPropsType<typeof getStaticProps> &
  ReturnType<typeof mapStateToProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const Payment = ({
  doc,
  main,
  accountRes,
  faqRes,
  basket,
  funnel,
  inStoreText,
  promotions,
  createCheckoutPayment,
  takeback,
  postSubPayment,
  postDadPayment,
  postBypassDadPayment,
  postWireTransferDadPayment,
  cart,
  parameters,
  checkout,
  banner,
  setFunnelStep,
  user,
  isLoggedIn,
}: TPaymentProps) => {
  const { putCoupon, getCart, deleteCoupon } = useCart()
  const classes = useFunnelStyle()
  const router = useRouter()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const informationSkipped = useInformationSkipped()
  const { trackPageView, trackEvent, pushInstruction } = useMatomo()
  const [code, setCode] = useState('')
  const [codeOperator, setCodeOperator] = useState('')
  const [minimumCartItemsError, setMinimumCartItemsError] = useState(false)
  const [couponValid, setCouponValid] = useState(false)
  const [couponError, setCouponError] = useState(false)
  const [couponRemoved, setCouponRemoved] = useState(false)
  const [errorCodeOperator, setErrorCodeOperator] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const hasStockError = useCartHasStockError()
  const stripePromise = useStripePromise(parameters?.items?.in_store)
  const [isLoader, setIsLoader] = useState(false)
  const [depositCompleted, setDepositCompleted] = useState(false)
  const [byPassCgu, setByPassCgu] = useState(false)
  const userBypassPayment = user?.bypassPayment === true && isLoggedIn
  const [byPassPayment, setByPassPayment] =
    useState<boolean>(brandBypassPayment)

  useEffect(() => {
    dispatch(
      SAVE_PRISMIC_DOCUMENTS({
        general: main?.data,
        funnel: funnel?.data,
        account: accountRes?.data,
        instore: inStoreText?.data,
      })
    )
  }, [funnel, main, inStoreText])

  // Extract swik_id from router query
  const { reference } = router.query

  const changeByPassCgu = () => {
    setByPassCgu(!byPassCgu)
  }

  useEffect(() => {
    trackPageView({ documentTitle: 'Payment' })
    // Fetch/refresh cart data when component mounts to ensure latest data
    const cartToken = localStorage.getItem('CartToken')
    if (
      cartToken &&
      cart?.item?.tokenValue &&
      cartToken !== cart?.item?.tokenValue
    ) {
      localStorage.setItem('CartToken', cart?.item?.tokenValue)
      getCart(cart?.item?.tokenValue)
    }
    setFunnelStep(getFunnelStepIndex('payment'))
  }, [])

  useEffect(() => {
    if (process.env.STORE_TYPE === 'classic_subscription') {
      promotions?.futurPrice === 0 && router.push('/shop')
    }
  }, [promotions])

  useEffect(() => {
    if (user?.bypassPayment || brandBypassPayment) {
      setByPassPayment(true)
    }
  }, [user])

  useEffect(() => {
    {
      // Redirect to shop page if no products in cart
      cart?.item?.items?.length === 0 &&
        cart?.status === 'cart live' &&
        checkout?.pdfResponse !== 'Order completed' &&
        router.push('/shop')
      checkTryOutError(cart) && router.push('/shop')
    }
  }, [cart?.item?.items, cart?.status, checkout])

  useEffect(() => {
    if (cart.item?.couponCode) {
      setCouponValid(true)
      setCode(cart.item?.couponCode)
    }
  }, [cart.item?.couponCode])

  const applyCoupon = async () => {
    setCouponValid(false)
    setCouponError(false)
    const isCoupon = await putCoupon(code)
    if (isCoupon.type === 'PUT_CART_COUPON_SUCCESS') {
      setCouponValid(true)
    } else {
      if (cart?.item?.couponCode !== code) {
        setCouponError(true)
      }
    }
  }

  const clearCoupon = async () => {
    await deleteCoupon()
    setCouponValid(false)
    setCouponError(false)
    setCouponRemoved(true)
    setCode('')
  }

  const handleCodeOperatorValue = (value) => {
    setCodeOperator(value)
  }

  const handleByPassOrder = async () => {
    if (hasStockError) return
    setIsLoader(true)
    setErrorMessage(false)
    setErrorCodeOperator(false)

    await createCheckoutPayment(cart.item.tokenValue)
    const data = {}

    if (brandBypassPayment && parameters?.items?.canByPassPayment) {
      data['email'] = localStorage.getItem('email')
      data['byPassPassword'] = byPassPassword ? byPassPassword : codeOperator
      data['byPassType'] = byPassPassword
        ? BY_PASS_TYPE.CUSTOMER
        : BY_PASS_TYPE.OPERATOR
    } else {
      if (byPassPayment) {
        data['byPassType'] = BY_PASS_TYPE.CUSTOMER
      }
      data['email'] = localStorage.getItem('email')
    }

    // Add swik_id if available from router query
    if (reference) {
      data['swik_id'] = reference
    }

    // add parcelShop id if exist
    if (
      cart?.item?.shipments[0].method?.type !== 'HOME_DELIVERY' &&
      typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' &&
      localStorage.getItem('rmsParcelShopId') !== null
    ) {
      data['parcelShopId'] = localStorage.getItem('rmsParcelShopId')
    }
    let payment = null
    if (!isSubscription) {
      if (userBypassPayment) {
        payment = await postBypassDadPayment(data, cart.item.tokenValue)
      } else {
        payment = await postDadPayment(data, cart.item.tokenValue)
      }
    } else {
      payment = await postSubPayment(data, cart.item.tokenValue)
    }

    if (payment?.paymentResult === 'Order completed') {
      await pushInstruction(
        'trackEcommerceOrder',
        cart?.item?.tokenValue,
        numberToPrice(cart?.item?.totals?.total),
        numberToPrice(cart?.item?.totals?.total - cart?.item?.totals?.shipping),
        numberToPrice(cart?.item?.totals?.taxes),
        numberToPrice(cart?.item?.totals?.shipping),
        numberToPrice(cart?.item?.totals?.promotion)
      )

      const gaParams = {
        transaction_id: cart?.item?.tokenValue,
        currency: cart?.item?.currency,
        value: numberToPrice(cart?.item?.totals?.total),
        tax: numberToPrice(cart?.item?.totals?.taxes),
        shipping: numberToPrice(cart?.item?.totals?.shipping),
        items: cart.item.items.map(({ product, quantity, total }) => {
          const firstVariant: any = Object.values(product?.variants)[0]
          return {
            ['item_name']: product?.name,
            ['item_id']: isChalhoub ? firstVariant?.sku : product?.code,
            ['item_variant']: isChalhoub && firstVariant?.code,
            price: numberToPrice(total),
            quantity,
          }
        }),
      }

      const GTMData = getPaymentInfoGtmData(
        cart,
        couponValid ? code : '',
        'bypass'
      )

      const cleanGAParams = clearItemVariantFromGAParamsIfNotChalhoub(gaParams)
      gtag.tracker(GAEvent.PURCHASE, cleanGAParams)
      safeDataLayerPush(GTMData)

      // Meta Pixel: Purchase event with amount and currency
      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', 'Purchase', {
          value: numberToPrice(cart?.item?.totals?.total),
          currency: cart?.item?.currency,
        })
      }

      await router.push('/confirmation')
      setIsLoader(false)
    }
    if (payment?.err) {
      setIsLoader(false)
      if (payment?.err?.response.data === 'wrong byPassPassword') {
        setErrorCodeOperator(true)
      } else if (payment?.err?.response.data === minimumCartItemsNotReached) {
        setMinimumCartItemsError(true)
      } else {
        setErrorMessage(true)
      }
    }
  }

  const handleWireTransferOrder = async () => {
    if (hasStockError) return
    setIsLoader(true)
    setErrorMessage(false)

    await createCheckoutPayment(cart.item.tokenValue)
    const data = {
      email: localStorage.getItem('email'),
      byPassType: BY_PASS_TYPE.CUSTOMER,
    }

    if (
      cart?.item?.shipments[0].method?.type !== 'HOME_DELIVERY' &&
      typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' &&
      localStorage.getItem('rmsParcelShopId') !== null
    ) {
      data['parcelShopId'] = localStorage.getItem('rmsParcelShopId')
    }

    const payment = await postWireTransferDadPayment(data, cart.item.tokenValue)

    if (payment?.paymentResult === 'Order completed') {
      await pushInstruction(
        'trackEcommerceOrder',
        cart?.item?.tokenValue,
        numberToPrice(cart?.item?.totals?.total),
        numberToPrice(cart?.item?.totals?.total - cart?.item?.totals?.shipping),
        numberToPrice(cart?.item?.totals?.taxes),
        numberToPrice(cart?.item?.totals?.shipping),
        numberToPrice(cart?.item?.totals?.promotion)
      )

      const gaParams = {
        transaction_id: cart?.item?.tokenValue,
        currency: cart?.item?.currency,
        value: numberToPrice(cart?.item?.totals?.total),
        tax: numberToPrice(cart?.item?.totals?.taxes),
        shipping: numberToPrice(cart?.item?.totals?.shipping),
        items: cart.item.items.map(({ product, quantity, total }) => {
          const firstVariant: any = Object.values(product?.variants)[0]
          return {
            ['item_name']: product?.name,
            ['item_id']: isChalhoub ? firstVariant?.sku : product?.code,
            ['item_variant']: isChalhoub && firstVariant?.code,
            price: numberToPrice(total),
            quantity,
          }
        }),
      }

      const GTMData = getPaymentInfoGtmData(
        cart,
        couponValid ? code : '',
        'wire_transfer'
      )

      const cleanGAParams = clearItemVariantFromGAParamsIfNotChalhoub(gaParams)
      gtag.tracker(GAEvent.PURCHASE, cleanGAParams)
      safeDataLayerPush(GTMData)

      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', 'Purchase', {
          value: numberToPrice(cart?.item?.totals?.total),
          currency: cart?.item?.currency,
        })
      }

      await router.push('/confirmation')
      setIsLoader(false)
    }
    if (payment?.err) {
      setIsLoader(false)
      if (payment?.err?.response.data === minimumCartItemsNotReached) {
        setMinimumCartItemsError(true)
      } else {
        setErrorMessage(true)
      }
    }
  }

  // Check if deposit is required
  const depositPercentage = process.env.SWIKLY_DEPOSIT_PERCENTAGE
    ? parseFloat(process.env.SWIKLY_DEPOSIT_PERCENTAGE)
    : 0
  const isDepositRequired =
    depositPercentage > 0 &&
    cart?.item?.items?.some((item) => item.type === 'RENTAL')
  const canProceedToPayment =
    (!isDepositRequired || depositCompleted) && !hasStockError

  return (
    <Layout
      mainLogo={main?.data?.logo}
      doc={main}
      metaTitle={prismicText(
        doc?.data?.meta_title_payment,
        t('texts:funnel:payement')
      )}
      hideTop
      t={t}
      inStoreText={inStoreText}
      metaDescription={doc?.data?.meta_description_payment}
      metaKeywords={doc?.data?.meta_keywords_payment}
      basket={basket}
      account={accountRes}
      faq={faqRes}
      banner={banner}
    >
      <main className={clsx('payment', 'checkout', classes.root)}>
        <div className={clsx('funnel', classes.funnel)}>
          <Container maxWidth={'xl'} data-testid={'payment'}>
            <div className={classes.funnelLayout}>
              <div className={classes.funnelContent}>
                <FunnelHeader
                  title={
                    doc?.data?.steps?.[0]?.['title']?.[0]?.text
                      ? doc?.data?.steps?.[0]?.['title']?.[0]?.text
                      : t('texts:funnel:payment:title')
                  }
                />
                <FunnelBox
                  steps={getStepperSteps(
                    doc?.data?.steps,
                    doc?.data?.order_reference_label,
                    { informationSkipped }
                  )}
                  t={t}
                  activeStep={getFunnelStepIndex('payment', {
                    informationSkipped,
                  })}
                >
                  <Link href={getPrevFunnelRoute('payment')} passHref>
                    <a
                      onClick={() =>
                        trackEvent({
                          category: `Payment`,
                          action: `Return to shipping`,
                        })
                      }
                    >
                      <Typography
                        variant={'body2'}
                        className={classes.backLink}
                        component="span"
                      >
                        <KeyboardBackspaceIcon className={classes.backArrow} />
                        <span>
                          <CMSText
                            asText
                            data={doc?.data?.return_button}
                            defaultText={t('texts:funnel:return_button')}
                          />
                        </span>
                      </Typography>
                    </a>
                  </Link>

                  {!byPassPayment && !canProceedToPayment && (
                    <div className={classes.center}>
                      {/* Swikly Caution Component */}
                      <SwiklyCaution
                        cart={cart}
                        parameters={parameters}
                        onCautionComplete={() => setDepositCompleted(true)}
                        depositExplanation={funnel?.data?.swikly_deposit_infos}
                        cautionInfo={funnel?.data?.swikly_caution_info}
                      />
                    </div>
                  )}
                  {!doc?.data?.disable_coupon && canProceedToPayment && (
                    <div className={`payment-coupon ${classes.center}`}>
                      <Typography
                        variant="h5"
                        component="h2"
                        className={classes.promoTitle}
                      >
                        {prismicText(
                          doc?.data?.coupon_title,
                          t('texts:funnel:coupon_title')
                        )}
                      </Typography>
                      <Grid
                        container
                        spacing={2}
                        alignItems={'center'}
                        wrap={'nowrap'}
                        className={'payment-coupon__grid'}
                      >
                        <Grid
                          item
                          xs="auto"
                          className={clsx(
                            'payment-coupon__field',
                            classes.promoField
                          )}
                        >
                          <TextField
                            type="text"
                            name="promoCode"
                            placeholder={prismicText(
                              doc?.data?.coupon_label,
                              t('texts:funnel:coupon_label')
                            )}
                            value={code}
                            required={false}
                            onChange={setCode}
                          />
                        </Grid>
                        <Grid
                          item
                          xs="auto"
                          className={clsx(
                            'payment-coupon__cta',
                            classes.promoCTA
                          )}
                        >
                          <Button
                            size={'small'}
                            variant={'contained'}
                            color={'secondary'}
                            onClick={() => applyCoupon()}
                            className={classes.btnCoupon}
                          >
                            {prismicText(
                              doc?.data?.coupon_cta,
                              t('texts:funnel:coupon_cta')
                            )}
                          </Button>
                        </Grid>
                      </Grid>

                      <div className={classes.alignCenter}>
                        <div className={classes.couponSentences}>
                          {cart?.item?.couponCode && (
                            <Typography
                              variant={'body2'}
                              color={'secondary'}
                              className={'promo__code'}
                            >
                              {prismicText(
                                doc?.data?.coupon_applied,
                                t('texts:funnel:coupon_applied')
                              )}{' '}
                              {cart?.item?.couponCode}
                            </Typography>
                          )}
                          {couponValid && (
                            <Typography
                              variant={'body2'}
                              color={'secondary'}
                              className={'promo__code'}
                            >
                              {prismicText(
                                doc?.data?.coupon_success,
                                t('texts:funnel:coupon_success')
                              )}
                            </Typography>
                          )}
                          {couponRemoved && (
                            <Typography
                              variant={'body2'}
                              color={'secondary'}
                              className={'promo__code'}
                            >
                              {prismicText(
                                doc?.data?.coupon_removed,
                                t('texts:funnel:coupon_removed')
                              )}
                            </Typography>
                          )}
                          {couponError && (
                            <Typography variant={'body2'} color={'error'}>
                              {prismicText(
                                doc?.data?.coupon_error,
                                t('texts:funnel:coupon_error')
                              )}
                            </Typography>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {!userBypassPayment && byPassPayment && !byPassPassword && (
                    <div className={`payment-code-operator ${classes.center}`}>
                      <Typography
                        variant="h5"
                        component="h2"
                        className={classes.codeOperatorTitle}
                      >
                        {prismicText(
                          funnel?.data?.code_operator_label,
                          t('texts:funnel:payment:code_operator_label')
                        )}
                      </Typography>
                      <Grid
                        container
                        spacing={2}
                        alignItems={'center'}
                        wrap={'nowrap'}
                      >
                        <Grid
                          item
                          xs="auto"
                          className={classes.codeOperatorField}
                        >
                          <TextField
                            type="text"
                            name="codeOperator"
                            placeholder={prismicText(
                              funnel?.data?.code_operator_placeholder,
                              t(
                                'texts:funnel:payment:code_operator_placeholder'
                              )
                            )}
                            value={codeOperator}
                            required
                            onChange={handleCodeOperatorValue}
                            // onKeyPress={handleCheckCodeOperatorOnEnter}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {byPassPayment && funnel?.data?.cgu[0]?.text?.length > 0 && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={byPassCgu}
                          onChange={changeByPassCgu}
                        />
                      }
                      label={
                        <Typography
                          variant={'body2'}
                          component={'span'}
                          className={classes.cgu}
                        >
                          <CMSText
                            data={funnel?.data?.cgu}
                            defaultText={t('texts:funnel:payment:cgu')}
                          />
                        </Typography>
                      }
                    />
                  )}
                  {canProceedToPayment && (
                    <>
                      {!byPassPayment ? (
                        <div className={`payment-bycard ${classes.center}`}>
                          <Typography variant="h5" component="h2">
                            {prismicText(
                              doc?.data?.titleform,
                              t('texts:funnel:titleform')
                            )}
                          </Typography>

                          {isDepositRequired && (
                            <Typography
                              variant="body1"
                              color="textSecondary"
                              align="center"
                              style={{ marginBottom: 16 }}
                            >
                              <CMSText
                                asText
                                data={funnel?.data?.swikly_caution_info}
                                defaultText={t(
                                  'texts:funnel:payment:caution_info'
                                )}
                              />
                            </Typography>
                          )}

                          {process.env.NEXT_PUBLIC_CHECKOUT_KEY && (
                            <PaymentFormCheckout
                              publicKey={process.env.NEXT_PUBLIC_CHECKOUT_KEY}
                              text={doc?.data}
                              t={t}
                              settings={main?.data}
                              coupon={couponValid ? code : ''}
                              swikId={reference}
                              disabled={!canProceedToPayment}
                            />
                          )}
                          {process.env.STRIPE_KEY &&
                            !process.env.PAYPAL_CLIENT_ID &&
                            stripePromise &&
                            cart?.item?.startLeasingDate && (
                              <Elements stripe={stripePromise}>
                                <PaymentFormStripe
                                  text={doc?.data}
                                  t={t}
                                  startLeasingDate={
                                    cart && cart?.item?.startLeasingDate
                                  }
                                  coupon={couponValid ? code : ''}
                                  swikId={reference}
                                  disabled={!canProceedToPayment}
                                />
                              </Elements>
                            )}
                          {process.env.USE_ADYEN &&
                            !process.env.PAYPAL_CLIENT_ID &&
                            cart?.item?.startLeasingDate && (
                              <PaymentFormAdyen
                                text={doc?.data}
                                t={t}
                                startLeasingDate={
                                  cart && cart?.item?.startLeasingDate
                                }
                                coupon={couponValid ? code : ''}
                                swikId={reference}
                                disabled={!canProceedToPayment}
                              />
                            )}
                          {process.env.STRIPE_KEY &&
                            process.env.PAYPAL_CLIENT_ID &&
                            stripePromise &&
                            cart?.item?.startLeasingDate && (
                              <PaymentAccordion
                                cardComponent={
                                  <Elements stripe={stripePromise}>
                                    <PaymentFormStripe
                                      text={doc?.data}
                                      t={t}
                                      startLeasingDate={
                                        cart && cart?.item?.startLeasingDate
                                      }
                                      coupon={couponValid ? code : ''}
                                      swikId={reference}
                                      disabled={!canProceedToPayment}
                                    />
                                  </Elements>
                                }
                                paypalComponent={
                                  <PaymentPaypal
                                    doc={doc}
                                    startLeasingDate={
                                      cart && cart?.item?.startLeasingDate
                                    }
                                    coupon={couponValid ? code : ''}
                                    disabled={!canProceedToPayment}
                                  />
                                }
                              />
                            )}
                          {process.env.USE_ADYEN &&
                            process.env.PAYPAL_CLIENT_ID &&
                            cart?.item?.startLeasingDate && (
                              <PaymentAccordion
                                cardComponent={
                                  <PaymentFormAdyen
                                    text={doc?.data}
                                    t={t}
                                    startLeasingDate={
                                      cart && cart?.item?.startLeasingDate
                                    }
                                    coupon={couponValid ? code : ''}
                                    swikId={reference}
                                    disabled={!canProceedToPayment}
                                  />
                                }
                                paypalComponent={
                                  <PaymentPaypal
                                    doc={doc}
                                    startLeasingDate={
                                      cart && cart?.item?.startLeasingDate
                                    }
                                    coupon={couponValid ? code : ''}
                                    disabled={!canProceedToPayment}
                                  />
                                }
                              />
                            )}
                          {isWireTransferEnabled && isLoggedIn && (
                            <div
                              className={classes.alignCenter}
                              style={{ marginTop: 24 }}
                            >
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                align="center"
                                style={{ marginBottom: 8 }}
                              >
                                {t(
                                  'texts:funnel:payment:wire_transfer_separator',
                                  'Or'
                                )}
                              </Typography>
                              {isLoader ? (
                                <Loader />
                              ) : (
                                <Button
                                  className={'payment-form__wire-transfer'}
                                  variant="outlined"
                                  color="primary"
                                  onClick={handleWireTransferOrder}
                                  type="button"
                                  disabled={hasStockError}
                                >
                                  {t(
                                    'texts:funnel:payment:wire_transfer_button',
                                    'Pay later with a wire transfer'
                                  )}
                                </Button>
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className={classes?.alignCenter}>
                          {isLoader ? (
                            <Loader />
                          ) : (
                            <Button
                              className={'payment-form__submit'}
                              variant="contained"
                              data-testid="paymentSubmit"
                              color="primary"
                              onClick={handleByPassOrder}
                              type="submit"
                              disabled={
                                hasStockError ||
                                (funnel?.data?.cgu[0]?.text.length > 0
                                  ? !byPassCgu
                                  : false)
                              }
                            >
                              <CMSText
                                asText
                                data={funnel?.data?.operator_button_validation}
                                defaultText={t(
                                  'texts:funnel:payment:errors:operator_button_validation'
                                )}
                              />
                            </Button>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  {errorMessage && (
                    <Typography
                      color={'error'}
                      variant={'body1'}
                      align={'center'}
                    >
                      {t('texts:funnel:payment:error')}
                    </Typography>
                  )}
                  {errorCodeOperator && (
                    <Typography
                      color={'error'}
                      variant={'body1'}
                      align={'center'}
                    >
                      <CMSText
                        data={funnel?.data?.wrong_code_operator}
                        defaultText={t(
                          'texts:funnel:payment:errors:wrong_code_operator'
                        )}
                      />
                    </Typography>
                  )}
                  {minimumCartItemsError && (
                    <Typography
                      color={'error'}
                      variant={'body1'}
                      align={'center'}
                    >
                      {t('texts:funnel:payment:errors:minimum_cart_items')}
                    </Typography>
                  )}
                  {isPrismicText(doc?.data?.data_text) && (
                    <TextBox text={doc?.data?.data_text} />
                  )}
                  <Grid container spacing={2}>
                    {doc?.data
                      ? doc?.data.commitment.map((commit, index) => {
                          return (
                            <Grid item xs={12} md={6} key={index}>
                              <Commitment
                                center={true}
                                icon={commit.icon.url}
                                title={prismicText(commit?.title)}
                                desc={prismicText(commit?.text)}
                              />
                            </Grid>
                          )
                        })
                      : [0, 1].map((index) => {
                          return (
                            <Grid item xs={12} md={6} key={index}>
                              <Commitment
                                center={true}
                                icon={'/images/placeholder.jpg'}
                                title={t('texts:general:add_a_title')}
                                desc={t('texts:general:add_a_description')}
                              />
                            </Grid>
                          )
                        })}
                  </Grid>
                </FunnelBox>
              </div>
              <div className={classes.funnelAside}>
                <FunnelAside
                  text={funnel?.data}
                  basket={basket}
                  parameters={parameters}
                  takeback={takeback}
                  settings={main}
                  deleteCoupon={clearCoupon}
                />
              </div>
            </div>
          </Container>
        </div>
      </main>
    </Layout>
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const takeback = await getSingleDocument(client, lang, 'take_back')
  const general = await getSingleDocument(client, lang, 'general')
  const basket = await getSingleDocument(client, lang, 'basket')
  const funnel = await getSingleDocument(client, lang, 'funnel')
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const accountRes = await getSingleDocument(client, lang, 'account')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')

  return {
    props: {
      doc: funnel,
      takeback,
      main: general,
      inStoreText,
      basket,
      funnel,
      accountRes,
      faqRes,
      banner,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Payment)
